var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import FormFieldInput, {} from '../form-field-input';
import USERNAME_REGEX from '../../validations/validations-username';
const FormFieldUsername = (_a) => {
    var { name = 'username', reference = 'username', required = true, size = undefined, textInfo = '', textValidationMessages = {}, value = '', componentName = 'form-field-username' } = _a, props = __rest(_a, ["name", "reference", "required", "size", "textInfo", "textValidationMessages", "value", "componentName"]);
    return (_jsx(FormFieldInput, Object.assign({ autocomplete: "username", componentName: componentName, label: "Inlognaam", maxlength: 40, name: name, pattern: USERNAME_REGEX, reference: reference, required: required, size: size, textInfo: textInfo, textValidationMessages: textValidationMessages, type: "text", value: value }, props)));
};
export default FormFieldUsername;
